<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qHJ65m/tc-custom/9781459205987.jpg?1723288488827" alt="This image is the cover for the book Cowboy Brigade, Daddy Corps"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cowboy Brigade, Daddy Corps
      </h1>
      <p class="bookDescription body article font2">
        <b>A special agent is back in Texas to investigate a crime heartbreakingly close to home in the <i>New York Times</i>–bestselling author’s romantic suspense series.</b><br/><br/>Agent Wade Coltrane, ex-Army Special Forces, has returned home to Freedom, Texas, for his next assignment: infiltrate the Long K Ranch and bust the owner for attempted murder. The obstacle: Lindsay Kemp, his high school sweetheart—and his target’s granddaughter. <br/><br/>Wade didn’t expect Lindsay to still be living on the ranch—or to be a single mother every bit as beautiful and spirited as he remembered. Each day he spends undercover only intensifies his lingering desire for Lindsay and rouses his protective instincts. And he’ll need them, for there’s a killer on the ranch, and he’s set his vengeful sights on Lindsay. . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elle James
      </h2>
      
      <p class="authorDescription body article">Raised an Air Force brat, Elle James got her work ethic from her dad, creativity from mom and inspiration from her sister. As a member of the reserves, she's traveled, managed a career, and raised three children. She and her husband even raised ostriches and emus. Ask her what it's like to go toe-to-toe with a 350-pound bird!&#160;Former manager of computer programmers, Elle is happy to write full time in NW Arkansas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?787ca156